import { FlexRow, MaterialIcon, StyledButton, useModal } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { MASSIVE_COMMANDS_FILE_EXAMPLE } from '../../constants/massiveCommands';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { getFileUrlByKey } from '../../services/appService';
import StyledTooltip from '../ui/StyledTooltip';
import NewMassiveCommsModal from './modal/NewMassiveCommsModal';

type Props = {
  onReloadPage: () => void;
};

export function MassiveCommsFiltersBar({ onReloadPage }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { openModal: openFormModal, closeModal: closeFormModal, showModal: showFormModal } = useModal();
  const { showFailFeedback } = useFeedback();

  const onDownloadExample = async () => {
    const { url, error } = await getFileUrlByKey(MASSIVE_COMMANDS_FILE_EXAMPLE);
    if (url) {
      window.open(url, '_blank');
    } else {
      showFailFeedback(error || 'Ocurrió un error al descargar el archivo, inténtalo más tarde.');
    }
  };

  return (
    <>
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={css({
          justifyContent: 'end',
          width: '100%',
        })}
      >
        <StyledTooltip
          content="Ejemplo de archivo"
          showArrow={false}
        >
          <Button
            kind="tertiary"
            shape="square"
            size="compact"
            onClick={onDownloadExample}
          >
            <MaterialIcon name={'info'} />
          </Button>
        </StyledTooltip>
        <StyledTooltip
          content={'Recargar tabla'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onReloadPage}
            kind="tertiary"
          >
            <MaterialIcon name={'refresh'} />
          </Button>
        </StyledTooltip>
        <StyledButton
          onClick={openFormModal}
          startEnhancer={
            <MaterialIcon
              name="add"
              size="xs-mini"
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Nuevo
        </StyledButton>
      </FlexRow>
      {showFormModal && (
        <NewMassiveCommsModal
          onClose={(updateTable) => {
            if (updateTable) {
              onReloadPage();
            }
            closeFormModal();
          }}
          isOpen={showFormModal}
        />
      )}
    </>
  );
}
